// extracted by mini-css-extract-plugin
module.exports = {"container":"Aa","breakline":"Ab","contentFrame":"Ac","content":"Ad","rentalNotesFrame":"Ae","description":"Af","ratingReason":"Ah"};